export default [
    {
        name: 'fox',
        type: 'gltfModel',
        path: 'models/Fox/glTF/Fox.gltf',
        scale: 0.02
    },
    {
        name: 'mouse',
        type: 'gltfModel',
        path: 'models/Fox/glTF/Fox.gltf',
        scale: 0.01
    }
]